import {Subject} from 'rxjs';

export class FetchOnboardingGoals {
    public static readonly type = '[Orders] FetchOnboardingGoals';

    constructor(public accountId: number, public cancellationToken?: Subject<any>) {
    }

}

export class FetchOrder {
    public static readonly type = '[Orders] FetchOrder';

    constructor(public accountId: number, public orderNo: string, public cancellationToken?: Subject<any>) {
    }

}
